// T-1 / T-2 转换主流程接口
import request, { triggerDownload, normalizeError } from './request';

// 格式识别：上传原始文件，返回扩展名 vs 内容的一致性信息
export function detectFile(file) {
  const form = new FormData();
  form.append('file', file);
  return request.post('/api/detect', form, { timeout: 30000 });
}

// 能力查询：列出某源格式可转的目标格式（含四类损耗标签）
export function getCapability(source) {
  return request.get('/api/capability', { params: { source } });
}

// 创建转换任务（async 走线程池，默认 true 以便前端轮询进度）
export function createTask({ file, source, target, async = true }) {
  const form = new FormData();
  form.append('file', file);
  form.append('source', source);
  form.append('target', target);
  form.append('async', async ? 'true' : 'false');
  return request.post('/api/tasks', form, { timeout: 60000 });
}

// 查询单个任务状态与进度
export function getTask(id) {
  return request.get(`/api/tasks/${id}`, { timeout: 30000 });
}

// 删除我的文件（隐私清理）
export function deleteFile(id) {
  return request.delete(`/api/files/${id}`);
}

// OCR 识别（异步任务）：提交后立即返回 taskId，长文档不再超时
//
// 入参二选一（后端 /api/tasks/ocr 同口径）：
//   * file   —— 新选的本地文件（multipart 上传）
//   * fileId —— 已上传文件的存储名（/api/files/upload/multiple 的返回值）。
//               转换页「发现是扫描件 → 改用 OCR」走这条：文件早就传上去了，
//               再传一遍纯属浪费用户流量。
export function createOcrTask({ file, fileId, target, mode = 'auto', engine = 'auto' }) {
  const form = new FormData();
  if (file) form.append('file', file);
  if (fileId) form.append('fileId', fileId);
  form.append('target', target);
  form.append('mode', mode); // auto=按页分流（推荐）｜all=整份 OCR
  // engine=识别通道：cloud 是订阅专属、按页计费的高速通道。
  // ⛔ 网页端免费、没有付费路径 → **后端强制降级为 local**（见
  //    ceanx/security.py::ocr_engine_for_client），这里传什么都不可能上云。
  //    网关那道限制是硬约束，别在前端改参数以为能开。
  form.append('engine', engine);
  return request.post('/api/tasks/ocr', form, { timeout: 60000 });
}

// 下载任务结果（以任务为单位，不依赖输出文件名）
export function fetchTaskResult(id) {
  return request.get(`/api/tasks/${id}/result`, { responseType: 'blob' });
}

// 下载结果文件（blob）
export function fetchFile(filePath) {
  return request.get('/api/files/download', {
    params: { filePath },
    responseType: 'blob'
  });
}

// 下载并落盘：filePath 为存储名，originalName 为展示用原名
export async function downloadAndSave(filePath, originalName) {
  const resp = await fetchFile(filePath);
  triggerDownload(resp.data, originalName || filePath);
}

export { normalizeError };
